<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="menuData != ''">
            <div class="container-fluid xyz">
                <div class="admin-page-content">
                    <div class="internal-container">
                        <div class="bullentin-questin-answer">
                            <div class="page-title-container">
                                <div class="page-name">{{postData.title}}</div>
                                <button type="submit" class="btn btn-primary pull-right bg-color-098de1" v-on:click.prevent="backButton()">
                                    Back
                                </button>
                            </div>
                            <div class="answers">
                                <span v-html="postData.description" v-linkified:options="{ className: '' }"></span>
                                <div class="clearfix"></div>
                                <div class="bullentintext">
                                    <template v-if='postData.documents && postData.documents.length > 0'>
                                        <h5>Corresponding Files</h5>
                                        <div class="attachmentContainer">
                                            <template>
                                                <swiper class="" :options="swiperOptionAttachments" ref="mySwiper">
                                                    <template v-for="(doc, index1) in postData.documents">
                                                        <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                            <swiper-slide>
                                                                <img :src="doc.document" @click="openGallery(postData.documents,index1)">
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                            <swiper-slide>
                                                                <a href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)"><img src="/static/images/doc-icon.webp" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                            <swiper-slide>
                                                                <a href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)"><img src="/static/images/xl-icon.webp" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                            <swiper-slide>
                                                                <a href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)"><img src="/static/images/ppt-icon.webp" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                            <swiper-slide>
                                                                <a href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)"><img src="/static/images/pdf-icon.webp" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else>
                                                            <swiper-slide>
                                                                <a href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)"><img src="/static/images/link-icon.webp" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                    </template>
                                                </swiper>
                                            </template>
                                        </div>
                                        <!--<div class="attachmentContainer">
                                            <template v-for="(doc, index1) in postData.documents">
                                                <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                    <img :src="doc.document" @click="openGallery(postData.documents,index1)">
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else>
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                </template>
                                            </template>
                                        </div>-->
                                    </template>
                                </div>
                            </div>

                        </div>
                        <!--<div class="bulletin-board-listing">
                            <div class="comment-section full-comment-section">
                                <div class="avtarimg">
                                    <img src="/static/images/default.jpg">
                                </div>
                                <div class="comment-textarea">
                                    <textarea placeholder="Add a Comment..."></textarea>
                                    <a href="#" class="commentbtn">Comment</a>
                                </div>
                            </div>
                        </div>-->
                        <!--<div class="bulletin-board-listing bulletin-board-listing-details">
                            <div class="bulletin-view">
                                <div class="avtarimg">
                                    <img src="/static/images/default.jpg">
                                </div>
                                <div class="bulletin-view-details">
                                    <div class="bullentin-internal-details">
                                        <div class="useravtarname">Gaurav Deshmukh</div>
                                        <div class="bullentininfo">20 January, 2019 &nbsp; | &nbsp;4:30 PM</div>
                                    </div>
                                    <div class="bullentin-board-listing-top">
                                        <div class="vote-count">
                                            <img src="/static/images/vote-count.png">
                                            Upvote  23
                                        </div>
                                        <div class="bullentin-comments-count">
                                            <img src="/static/images/comments-icon.png">
                                            Comment  (8)
                                        </div>
                                        <div class="commentsview">25 Views</div>
                                    </div>
                                    <div class="bullentintext">
                                        VPOD is Variable Pressure Output Device. During engine EGR (Exhaust Gas Recirculation) operation, the VPOD provides modulated air pressure to the pneumatic actuators which change the VNT (Variable Nozzle Turbine) vanes and EGR valve positions.<br/><br/>

                                        VNTs, (also known as Variable-geometry turbochargers (VGTs), are a family of turbochargers, usually designed to allow the effective aspect ratio (A:R) of the turbo to be altered as conditions change. This is done because optimum aspect ratio at low engine speeds is very different from that at high engine speeds. If the aspect ratio is too large, the turbo will fail to create boost at low speeds; if the aspect ratio is too small, the turbo will choke the engine at high speeds, leading to high exhaust manifold pressures, high pumping losses, and ultimately lower power output.
                                        By altering the geometry of the turbine housing as the engine accelerates, the turbo's aspect ratio can be maintained at its optimum.<br/><br/>

                                        These alterations are achieved by VPOD.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bulletin-board-listing bulletin-board-listing-details">
                            <div class="bulletin-view">
                                <div class="avtarimg">
                                    <img src="/static/images/default.jpg">
                                </div>
                                <div class="bulletin-view-details">
                                    <div class="bullentin-internal-details">
                                        <div class="useravtarname">Colton Baron</div>
                                        <div class="bullentininfo">20 January, 2019 &nbsp; | &nbsp;4:30 PM</div>
                                    </div>
                                    <div class="bullentin-board-listing-top">
                                        <div class="vote-count">
                                            <img src="/static/images/vote-count.png">
                                            Upvote  23
                                        </div>
                                        <div class="bullentin-comments-count">
                                            <img src="/static/images/comments-icon.png">
                                            Comment  (8)
                                        </div>
                                        <div class="commentsview">25 Views</div>
                                    </div>
                                    <div class="bullentintext">
                                        Vpod. Variable pressure output device. Part of the EGR system. Exhaust gas recirculation. Helps cut emissions.
                                    </div>
                                </div>
                            </div>
                        </div>-->
                        
                        <!-- Show and Load Discussion Images within the Model's Pop-Up Display, With The Ability To Switch Between Images. -->
                        <b-modal size="lg" class="gallery_modal" id="modal1" ref="myModalRef" hide-footer :hide-header=true>
                            <img class="w-100 mb-3" :src="viewImage">
                            <div class="clearfix"></div>
                            <div class="image-arrows customIconModelFooter clearfix">
                                <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                                <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <no-access></no-access>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    var exten = ['gif', 'jpg', 'jpeg', 'png'];
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    import { Button } from 'bootstrap-vue/es/components';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */
    import NoAccessPage from "@/components/NoAccessPage/NoAccessPage";

    Vue.component("app-footer", Footer);
    export default {
        name: 'CommonPage',
        components: {
            swiper,
            swiperSlide,
            'no-access': NoAccessPage
        },
        mixins: [commonMixins],
        data() {
            return {
                swiperOptionAttachments: {
                    slidesPerView: 14.5,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 12.5
                        },
                        1400: {
                            slidesPerView: 11.4
                        },
                        1300: {
                            slidesPerView: 10.4
                        },
                        1200: {
                            slidesPerView: 9.5
                        },
                        1000: {
                            slidesPerView: 9.5
                        },
                        667: {
                            slidesPerView: 7.5
                        },
                        480: {
                            slidesPerView: 5.5
                        },
                        360: {
                            slidesPerView: 4.5
                        }
                    }
                },

                postData: {
                    documents: [],
                    postId: [],
                },
                lightboxImages: [],
                lightboxImagesName: [],

                viewImage: '',
                viewImageName: '',
                index: 0,
            }
        },
        created: function () {

        },
        beforeMount: function () {
            var self = this;
        },
        mounted: function () {
            var self = this;
            self.postId = localStorage.getItem('post_id');
            self.getMenuSlug();
            $("html, body").animate({scrollTop: 0}, 10);
        },
        methods: {
            //common call methods to get slug and change route in watch and mounted method.
            getMenuSlug: function () {
                var self = this;
                self.menuSlug = this.$route.params.type;
                self.getMenuDetails(self.menuSlug);
                self.loadSalesData();
            },

            loadSalesData: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {'slug': self.menuSlug, id: self.postId}
                };
                self.showLoader();
                HTTP.get("display_sales_details", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.postData = response.data.content;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            /* Display Sales Data End*/
            /* display user name in formated string */
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            /*get user's initials from firstname lastname */
            getInitials: function (string) {
                var names = string.split(' ');
                var initials = "";
                $.each(names, function (i) {
                    initials += names[i].charAt(0);
                });
                return initials.toUpperCase();
            },
            /* Get images for gallery view */
            openGallery: function (documents, index) {
                var self = this;
                var arr = [];
                var new_index = 0;
                var file_name_arr = [];

                $.each(documents, function (i) {
                    if (jQuery.inArray(documents[i].doc_extension.toLowerCase(), exten) !== -1) {
                        if (i == index) {
                            index = new_index;
                        }
                        
                        arr.push(documents[i].document);
                        file_name_arr.push(documents[i].document_path);
                        new_index = new_index + 1;
                    }
                });
                self.loadImagesInLightBox(arr, index, file_name_arr);
            },
            loadImagesInLightBox: function (arr, index, file_name_arr) {
                var self = this;
                self.lightboxImages = arr;
                self.lightboxImagesName = file_name_arr;
                
                self.index = index;
                self.viewImage = self.lightboxImages[self.index];
                self.viewImageName = self.lightboxImagesName[self.index];
                self.$refs.myModalRef.show();
            },
            changeImage: function (move) {
                var self = this;
                if (move == 'next') {
                    self.index = self.index + 1;
                    if (self.lightboxImages.length <= self.index) {
                        self.index = 0;
                    }
                } else {
                    self.index = self.index - 1;
                    if (self.index < 0) {
                        self.index = (self.lightboxImages.length - 1);
                    }
                }
                self.viewImage = self.lightboxImages[self.index];
                self.viewImageName = self.lightboxImagesName[self.index];
            },
            backButton: function () {
                var self = this;
                self.$router.push({name: 'CommonPage', params: {type: self.menuSlug}});
            }
        }
    };
</script>